<template>
  <v-card style="height: 100%">
    <v-toolbar dense>
      <v-text-field
          v-model="search"
          label="Hledat..."
          debounce="5000"
          hide-details
      ></v-text-field>
      <month-picker v-model="monthFilter" hide-details />
      <v-checkbox
          v-model="validnow"
          label="Dnešní"
          hide-details
      ></v-checkbox>
    </v-toolbar>
    <GmapMap
        :center="center"
        :zoom="13"
        map-type-id="hybrid"
        style="width: 100%; height: calc(100% - 48px);"
        :options="{
          styles: [
              { featureType: 'all', stylers: [{ visibility: 'off' }] },
              { featureType: 'road', stylers: [{ visibility: 'on' }] },
              { featureType: 'water', stylers: [{ visibility: 'on' }] },
              { featureType: 'landscape', stylers: [{ visibility: 'on' }] },
              { featureType: 'administrative', stylers: [{ visibility: 'on' }] },
          ]
        }"
        @click="openedItem = null"
    >
      <GmapMarker
          v-if="currentPosition"
          :position="currentPosition"
          :icon="{
            path: 0, // CIRCLE
            scale: 10,
            fillOpacity: 1,
            strokeWeight: 2,
            fillColor: '#5384ED',
            strokeColor: '#ffffff',
          }"
          title="Vaše poloha"
      />
      <GmapMarker
          :key="index"
          v-for="(item, index) in items"
          :position="itemPosition(item)"
          :title="item.description + ' ' + item.address + ' ' + item.name"
          :clickable="true"
          @click="openedItem = item"
      />
      <gmap-info-window
          :options="{
          maxWidth: 500,
          pixelOffset: { width: 0, height: -35 },
          shouldFocus: true,
        }"
          :position="itemPosition(openedItem)"
          :opened="!!openedItem"
          @closeclick="openedItem = null">
        <v-simple-table v-if="!!openedItem">
          <template v-slot:default>
            <tbody>
            <tr>
              <th>Popis</th>
              <td>{{ openedItem.description }}</td>
            </tr>
            <tr>
              <th>Žadatel</th>
              <td>{{ openedItem.name }}</td>
            </tr>
            <tr>
              <th>Adresa</th>
              <td>{{ openedItem.address }}</td>
            </tr>
            <tr>
              <th>Platnost</th>
              <td>{{ new Date(openedItem.validfrom).toLocaleDateString('cs-cz').replace(/ /g,'') }} - {{ new Date(openedItem.validto).toLocaleDateString('cs-cz').replace(/ /g,'') }}</td>
            </tr>
            <tr>
              <th>Zjištění MP</th>
              <td>
                <v-chip v-if="openedItem.finding" color="green" text-color="white" link :href="downloadUrl(openedItem.id, 'finding')">
                  Zjištění MP
                </v-chip>
                <v-chip v-else color="red" text-color="white">
                  - - -
                </v-chip>
              </td>
            </tr>
            <tr>
              <th>Žádost</th>
              <td>
                <v-chip v-if="openedItem.request" color="green" text-color="white" link :href="downloadUrl(openedItem.id, 'request')">
                  Žádost
                </v-chip>
                <v-chip v-else color="red" text-color="white">
                  - - -
                </v-chip>
              </td>
            </tr>
            <tr>
              <th>Stanovisko MPO</th>
              <td>
                <v-chip v-if="openedItem.stand" color="green" text-color="white" link :href="downloadUrl(openedItem.id, 'stand')">
                  Stanovisko MPO
                </v-chip>
                <v-chip v-else color="red" text-color="white">
                  - - -
                </v-chip>
              </td>
            </tr>
            <tr>
              <th>Rozhodnutí DPO</th>
              <td>
                <v-chip v-if="openedItem.decision" color="green" text-color="white" link :href="downloadUrl(openedItem.id, 'decision')">
                  Rozhodnutí DPO
                </v-chip>
                <v-chip v-else color="red" text-color="white">
                  - - -
                </v-chip>
              </td>
            </tr>
            <tr>
              <th>Poplatek</th>
              <td>
                <v-chip v-if="openedItem.paid === 'paid'" color="green" text-color="white">Zaplaceno</v-chip>
                <v-chip v-if="openedItem.paid === 'notpaid'" color="red" text-color="white">Nezaplaceno</v-chip>
                <v-chip v-if="openedItem.paid === 'notrequired'" color="green" text-color="white">Bez poplatku</v-chip>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </gmap-info-window>
    </GmapMap>
  </v-card>
</template>

<script>
import MonthPicker from "@/components/MonthPicker";
import {api, defaultApiErrorHandler} from "@/main";

export default {
  name: "MapView",

  components: { MonthPicker },

  data: () => ({
    center: {
      lat: 48.940340739487645,
      lng: 16.73700009282884,
    },
    search: "",
    monthFilter: "",
    validnow: true,
    items: [],
    openedItem: null,
    currentPosition: null,
    watchLocationId: null,
  }),

  watch: {
    search() {
      this.loadDataFromServer();
    },
    monthFilter(val) {
      if (val) {
        this.validnow = false;
      }
      this.loadDataFromServer();
    },
    validnow(val) {
      if (val) {
        this.monthFilter = '';
      }
      this.loadDataFromServer();
    },
  },

  mounted(){
    console.log('mounted');
    this.loadDataFromServer();
    this.watchLocationId = navigator.geolocation.watchPosition( (position) => {
      console.log(position.coords);
      this.currentPosition = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    }, (err) => {
      console.warn('geolocation error', err);
    }, {
      enableHighAccuracy: true
    });
  },

  beforeUnmount() {
    console.log('beforeUnmount');
    navigator.geolocation.clearWatch(this.watchLocationId);
  },

  methods: {
    loadDataFromServer() {
      const params = {
        search: this.search,
        month: this.monthFilter,
        validnow: this.validnow ? true : undefined,
      };
      api
          .get('item.php', {params: params})
          .then(response => {
            console.log('response', response);
            this.items = response.data.items;
          })
          .catch(defaultApiErrorHandler);
    },

    itemPosition(item) {
      if (item && item.latitude && item.longitude) {
        return {
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
        };
      }
      return null;
    },
    downloadUrl (id, field) {
      return api.defaults.baseURL + 'download.php?id=' + id + '&field=' + field;
    },
  }
}
</script>
